import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Redirect, Link } from 'react-router-dom'
import RestaurantSummary from '../restaurants/RestaurantSummary2'
import { addFavorite } from '../../store/actions/restaurantActions'
import { NavLink } from 'react-router-dom'
import RestaurantCompare from '../restaurants/RestaurantCompare'
import { backupIssueAdmin, deleteIssueAdmin, backupReviewAdmin, deleteReviewAdmin, backupRestaurantAdmin, deleteRestaurantAdmin,
 deleteRestaurantCreateAdmin, setAddress, backupUserReviewAdmin, deleteUserReviewAdmin } from '../../store/actions/restaurantActions'
import { updateReduxUserReviews } from '../../store/actions/reduxActions'
import ReviewSummary from '../users/ReviewSummary'
import IssueSummary from '../users/IssueSummary'
import { firebaseConnect } from 'react-redux-firebase'
import firebase from 'firebase/app'
import  'firebase/database'
import { signOut } from '../../store/actions/authActions'

class UserDashboard extends Component {

 constructor (props){
     super(props);
     this.state = {
     project:'',
     location:'',
     state:'',
     city:'',
     zip:'',
     address:'',
     addressEncoded:'',
     url:'',
     userPoints: 0
    }
   }

  componentDidMount(){    
    if(this.props.issues && this.props.auth.uid){
      var issues = Object.entries(this.props.issues).filter(issue=>issue[1] !== null && issue[1].userId === this.props.auth.uid);
      var sortIssues = [];
      for(var issue in issues){
        sortIssues.push([issues[issue],issues[issue][1]['timestamp'].seconds]);
      }
      sortIssues.sort(function(a, b) {
         return a[1] - b[1];
        });
      
      var sortedIssues = [];
      for(var sortedIss in sortIssues){
        sortedIssues.push(sortIssues[sortedIss][0])
      }

      if(JSON.stringify(this.state.issues) !== JSON.stringify(sortedIssues)){
        this.setState({issues:sortedIssues});
      }
    }

    if(this.props.points && this.props.auth && this.props.points[this.props.auth.uid]){
      var userPoints = 0;
      for(var point in this.props.points[this.props.auth.uid]){
        userPoints = userPoints + this.props.points[this.props.auth.uid][point];
      }
      if(this.state.userPoints !== userPoints){
        this.setState({userPoints:userPoints})
      }
    }

    if(this.props.reviews || this.props.reviews === null){
      var userReviews = [];
      for(var rev in this.props.reviews){
        if(this.props.reviews[rev] !== null && this.props.reviews[rev].userId === this.props.auth.uid){
          userReviews.push([rev,this.props.reviews[rev].review])
        }
      }

      var sortUserReviews = [];

      for(var contRev in userReviews){
        sortUserReviews.push([userReviews[contRev],userReviews[contRev][1]['timestamp'].seconds]);
      }
      sortUserReviews.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedUserReviews = [];
      for(var sortedUR in sortUserReviews){
        sortedUserReviews.push(sortUserReviews[sortedUR][0])
      }


      if(sortedUserReviews && this.props.reduxStore && this.props.reduxStore.userReviews && JSON.stringify(this.props.reduxStore.userReviews !== JSON.stringify(sortedUserReviews))){
        this.props.updateReduxUserReviews(sortedUserReviews)
      }
      else if(sortedUserReviews && this.props.reduxStore && !this.props.reduxStore.userReviews){
        this.props.updateReduxUserReviews(sortedUserReviews)
      }  
    }
  }

  componentDidUpdate(){

    if(this.props.issues && this.props.auth.uid){
      var issues = Object.entries(this.props.issues).filter(issue=>issue[1] !== null && issue[1].userId === this.props.auth.uid);
      var sortIssues = [];
      for(var issue in issues){
        sortIssues.push([issues[issue],issues[issue][1]['timestamp'].seconds]);
      }
      sortIssues.sort(function(a, b) {
         return a[1] - b[1];
        });
      
      var sortedIssues = [];
      for(var sortedIss in sortIssues){
        sortedIssues.push(sortIssues[sortedIss][0])
      }

      if(JSON.stringify(this.state.issues) !== JSON.stringify(sortedIssues)){
        this.setState({issues:sortedIssues});
      }
    }

    if(this.props.issues === null && this.state.issues !== undefined){
      this.setState({issues: undefined})
    }

    if(this.props.points && this.props.auth && this.props.points[this.props.auth.uid]){
      var userPoints = 0;
      for(var point in this.props.points[this.props.auth.uid]){
        userPoints = userPoints + this.props.points[this.props.auth.uid][point];
      }
      if(this.state.userPoints !== userPoints){
        this.setState({userPoints:userPoints})
      }
    }

    if(this.props.reviews || this.props.reviews === null){
      var userReviews = [];
      for(var rev in this.props.reviews){
        if(this.props.reviews[rev] !== null && this.props.reviews[rev].userId === this.props.auth.uid){
          userReviews.push([rev,this.props.reviews[rev].review])
        }
      }

      var sortUserReviews = [];

      for(var contRev in userReviews){
        if(userReviews[contRev][1]){
          sortUserReviews.push([userReviews[contRev],userReviews[contRev][1]['timestamp'].seconds]);
        }
      }
      sortUserReviews.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedUserReviews = [];
      for(var sortedUR in sortUserReviews){
        sortedUserReviews.push(sortUserReviews[sortedUR][0])
      }


      if(sortedUserReviews && this.props.reduxStore && this.props.reduxStore.userReviews && JSON.stringify(this.props.reduxStore.userReviews !== JSON.stringify(sortedUserReviews))){
        this.props.updateReduxUserReviews(sortedUserReviews)
      }
      else if(sortedUserReviews && this.props.reduxStore && !this.props.reduxStore.userReviews){
        this.props.updateReduxUserReviews(sortedUserReviews)
      }  
    }
  }

  onFavorite = (project) => {
  if(this.props.user.firstName === "Guest"){
    alert("Guest Users may not add favorites")  
  }
  else{
    this.props.addFavorite(project);
  }
    }

  deleteInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("myModal").style.display = "block";
  }

  deleteCreateInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("myModalCreate").style.display = "block";
  }

  editCreate =(project)=>{
    this.setState({project:project, editCreate:true});
  }

  deleteIssueInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("myModalIssue").style.display = "block";
  }


  deleteReviewInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("deleteReviewModal").style.display = "block";
  }

  deleteUserReviewInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("deleteUserReviewModal").style.display = "block";
  }

  closeFunction =(e)=>{document.getElementById("myModal").style.display = "none";}
  closeFunctionCreate =(e)=>{document.getElementById("myModalCreate").style.display = "none";}
  closeFunctionIssue =(e)=>{document.getElementById("myModalIssue").style.display = "none";}
  closeFunctionDeleteReview =(e)=>{document.getElementById("deleteReviewModal").style.display = "none";}
  closeFunctionDeleteUserReview =(e)=>{document.getElementById("deleteUserReviewModal").style.display = "none";}
  closeFunctionLocate =(e)=>{document.getElementById("locateModal").style.display = "none";}

  handleSignOut(state){
   this.props.signOut(); 
  }

  handleDeleteReview = (e) => {
    e.preventDefault();
    this.props.backupReviewAdmin(this.state.project);
    this.props.deleteReviewAdmin(this.state.project);
    document.getElementById("deleteReviewModal").style.display = "none";
  }

  handleDeleteUserReview = (e) => {
    e.preventDefault();
    this.props.backupUserReviewAdmin(this.state.project[1]);
    this.props.deleteUserReviewAdmin(this.state.project[1], this.state.project[0]);
    document.getElementById("deleteUserReviewModal").style.display = "none";
  }

  handleDeleteCreate = (e) => {
    e.preventDefault();
    this.props.backupRestaurantAdmin(this.state.project);
    this.props.deleteRestaurantCreateAdmin(this.state.project);
    document.getElementById("myModalCreate").style.display = "none";
  }

  handleDeleteIssue = (e) => {
    e.preventDefault();
    this.props.backupIssueAdmin(this.state.project);
    this.props.deleteIssueAdmin(this.state.project[0]);
    document.getElementById("myModalIssue").style.display = "none";
  }

  handleDelete = (e) => {
    e.preventDefault();
    this.props.backupRestaurantAdmin(this.state.project);
    this.props.deleteRestaurantAdmin(this.state.project);
    document.getElementById("myModal").style.display = "none";
  }

  locateInterruptor = (e) => {
    e.preventDefault();
    this.calculateLocation(this.state.state, this.state.zip, this.state.city, this.state.address);
    document.getElementById("locateModal").style.display = "block";
  }

  handleLocate = (e) => {
    e.preventDefault();
    //update address
    this.props.setAddress(this.state.state, this.state.zip, this.state.city, this.state.address, this.state.location, this.props.user);
    document.getElementById("locateModal").style.display = "none";
  }


  calculateLocation = (state, zip, city, address) => {

    const Http = new XMLHttpRequest();
    const addressEncoded = encodeURIComponent(address);

    const url='https://dev.virtualearth.net/REST/v1/Locations/US/'+state+'/'+zip+'/'+city+'/'+addressEncoded+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';

    Http.open("GET", url);
    Http.send();
    const that = this;

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
        var parsedJSON = JSON.parse(Http.responseText);
        that.setState({httpResponse:parsedJSON})
        if(that.state.httpResponse !== ''){
          that.setState({location: that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates});
          that.setState({route:''});
        }
      }
      else{console.log('notready')}
    }
  }

  handleCompare = (project) => {
    if(document.getElementById(project.id+'compare').style.display==='none' || document.getElementById(project.id+'compare').style.display===''){
      document.getElementById(project.id+'compare').style.display = "block";  
    }
    else{
      document.getElementById(project.id+'compare').style.display = "none"; 
    }
  }

  closeCompare = (project) => {
    document.getElementById(project.id+"compare").style.display = "none";
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
  }
  handleAddress = (e) => {
    e.preventDefault();
    if(document.getElementById('address-input').style.display==='none' || document.getElementById('address-input').style.display===''){
      document.getElementById('address-input').style.display = "block";  
    }
    else{
      document.getElementById('address-input').style.display = "none"; 
    }  
  }
  handleSettings = (e) => {
    e.preventDefault();
    this.setState({goToSettings:true});
  }
  userInfoExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('expandRow').style.display==='none' || document.getElementById('expandRow').style.display===''){
      document.getElementById('expandRow').style.display = "block";  
    }
    else{
      document.getElementById('expandRow').style.display = "none"; 
    }
    document.getElementById('expandRow').scrollIntoView(false);  
  }
  messagesExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('messageExpand').style.display==='none' || document.getElementById('messageExpand').style.display===''){
      document.getElementById('messageExpand').style.display = "block";  
    }
    else{
      document.getElementById('messageExpand').style.display = "none"; 
    }  
    document.getElementById('messageExpand').scrollIntoView(false);
  }  

  contributionsExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('contributionsExpand').style.display==='none' || document.getElementById('contributionsExpand').style.display===''){
      document.getElementById('contributionsExpand').style.display = "block";  
    }
    else{
      document.getElementById('contributionsExpand').style.display = "none"; 
    }
    document.getElementById('contributionsExpand').scrollIntoView(false);
  }

  userReviewsExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('userReviewsExpand').style.display==='none' || document.getElementById('userReviewsExpand').style.display===''){
      document.getElementById('userReviewsExpand').style.display = "block";  
    }
    else{
      document.getElementById('userReviewsExpand').style.display = "none"; 
    }
    document.getElementById('userReviewsExpand').scrollIntoView(false);
  }

  issuesExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('issuesExpand').style.display==='none' || document.getElementById('issuesExpand').style.display===''){
      document.getElementById('issuesExpand').style.display = "block";  
    }
    else{
      document.getElementById('issuesExpand').style.display = "none"; 
    }
    document.getElementById('issuesExpand').scrollIntoView(false);
  }


  pendingContributionsExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('pendingContributionsExpand').style.display==='none' || document.getElementById('pendingContributionsExpand').style.display===''){
      document.getElementById('pendingContributionsExpand').style.display = "block";  
    }
    else{
      document.getElementById('pendingContributionsExpand').style.display = "none"; 
    }
    document.getElementById('pendingContributionsExpand').scrollIntoView(false);
  }

  pendingReviewsExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('pendingReviewsExpand').style.display==='none' || document.getElementById('pendingReviewsExpand').style.display===''){
      document.getElementById('pendingReviewsExpand').style.display = "block";  
    }
    else{
      document.getElementById('pendingReviewsExpand').style.display = "none"; 
    }
    document.getElementById('pendingReviewsExpand').scrollIntoView(false);
  }

  pendingCreateExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('pendingCreateExpand').style.display==='none' || document.getElementById('pendingCreateExpand').style.display===''){
      document.getElementById('pendingCreateExpand').style.display = "block";  
    }
    else{
      document.getElementById('pendingCreateExpand').style.display = "none"; 
    }
    document.getElementById('pendingCreateExpand').scrollIntoView(false);
  }

  pendingEditExpand = (e) => {
    e.preventDefault();
    if(document.getElementById('pendingEditExpand').style.display==='none' || document.getElementById('pendingEditExpand').style.display===''){
      document.getElementById('pendingEditExpand').style.display = "block";  
    }
    else{
      document.getElementById('pendingEditExpand').style.display = "none"; 
    }
    document.getElementById('pendingEditExpand').scrollIntoView(false);
  }


	render(){
    //if (!this.props.reduxStore.user) return <Redirect to ='/' />
		const { auth, restaurants, pending, favorites, users, user, issues,
     pendingCreate, pendingReviews, messages, reviewMessages, issueMessages } = this.props;
    
      if (!auth.uid) return <Redirect to='/signin' />
	    if (auth.uid !== this.props.match.params.id) return <Redirect to='/' /> 
		  if (this.state.goToSettings){
        return <Redirect to='/settings' />
      }
      if (this.state.editCreate){
        return <Redirect to={'/editCreate/' + this.state.project.id}/>
      }
      var isAdmin = auth.uid === "KXyK1sbPuOQamITgwh8c1gSAxOq2";

		var firstName = '';
		var lastName = '';		
    var userAddress = '';
    var location = '';
    var messagesLength = 0;
    var reviewMessagesLength = 0;
    var issueMessagesLength = 0;

    // fix this to just filter user once or get user info from firestore by matching auth
		if(user&&auth){
			firstName = user.firstName;
			lastName = user.lastName;
      userAddress = user.address;
      location = user.location;

		}
		var contributions = {'pendingCreate':'','pendingReviewsLength':'', 'pending':'', 'created':'','edited':'','pendingCreateLength':'', 'pendingLength':'', 'createdLength':'','editedLength':''};
		var newRestaurants = {};
		var newRestaurantsLength = 0;
		var createdAt, lastLoginAt;
    var sortCreated = [];
    var sortEdited = [];
    var sortPending = [];
    var sortPendingCreate = [];
    var sortPendingReviews = [];
    var sortReviews = [];

		if(restaurants&&auth&&pending&&pendingCreate&&users&&pendingReviews){
			contributions.created = restaurants.filter(restaurant=>restaurant.authorId === auth.uid);

      for(var conC in contributions.created){
        sortCreated.push([contributions.created[conC],contributions.created[conC]['createdAt'].seconds]);
      }
      sortCreated.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedCreated = [];
      for(var sortC in sortCreated){
        sortedCreated.push(sortCreated[sortC][0])
      }

			contributions.edited = restaurants.filter(restaurant=>restaurant.editorId === auth.uid);

      for(var conE in contributions.edited){
        sortEdited.push([contributions.edited[conE],contributions.edited[conE]['editedAt'].seconds]);
      }
      sortEdited.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedEdited = [];
      for(var sortE in sortEdited){
        sortedEdited.push(sortEdited[sortE][0])
      }

			contributions.pending = pending.filter(restaurant=>restaurant.editorId === auth.uid);
      
      for(var con in contributions.pending){
        if(contributions.pending[con]['editedAt']){
          sortPending.push([contributions.pending[con],contributions.pending[con]['editedAt'].seconds]);  
        }
      }
      sortPending.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedPending = [];
      for(var sort in sortPending){
        sortedPending.push(sortPending[sort][0])
      }

      contributions.pendingCreate = pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid);
  
      for(var cont in contributions.pendingCreate){
        sortPendingCreate.push([contributions.pendingCreate[cont],contributions.pendingCreate[cont]['createdAt'].seconds]);
      }
      sortPendingCreate.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedPendingCreate = [];
      for(var sorted in sortPendingCreate){
        sortedPendingCreate.push(sortPendingCreate[sorted][0])
      }
    
      contributions.pendingReviews = pendingReviews.filter(restaurant=>restaurant.userId === auth.uid);
	
      for(var contPR in contributions.pendingReviews){
        sortPendingReviews.push([contributions.pendingReviews[contPR],contributions.pendingReviews[contPR]['timestamp'].seconds]);
      }
      sortPendingReviews.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedPendingReviews = [];
      for(var sortedPR in sortPendingReviews){
        sortedPendingReviews.push(sortPendingReviews[sortedPR][0])
      }
  		


      contributions.createdLength = contributions.created.length;
			contributions.editedLength = contributions.edited.length;
			contributions.pendingLength = contributions.pending.length;
      contributions.pendingCreateLength =pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid).length;
      contributions.pendingReviewsLength = contributions.pendingReviews.length;
			
			createdAt = new Date(parseInt(auth.createdAt, 10)).toLocaleString();
			lastLoginAt = new Date(parseInt(auth.lastLoginAt, 10)).toLocaleString();

			newRestaurants = restaurants.filter(restaurant=> parseInt(restaurant.createdAt.seconds,10)*1000 > parseInt(auth.lastLoginAt,10));
			newRestaurantsLength = newRestaurants.length;

      if(messages){  
      messagesLength = Object.keys(messages).length;
      }
      
      if(reviewMessages){  
      reviewMessagesLength = Object.keys(reviewMessages).length;
      }

      if(issueMessages){  
      issueMessagesLength = Object.keys(issueMessages).length;
      }

      if(messages !== undefined && reviewMessages !== undefined && issueMessages !== undefined){
        var sortMessages = [];
        // array check is because deleted data was persisting in firestore
        if(messages && !Array.isArray(messages) && messages !== null){
          for(var message in messages){
            if(messages[message] !== undefined && messages[message] !== null && messages[message]['timestamp']){
              if(messages[message]['project']['restaurantId']){
                sortMessages.push([message, messages[message]['timestamp'].seconds, true, "edit"])    
              }
              else{
                sortMessages.push([message, messages[message]['timestamp'].seconds, true, "creation"])  
              }
              
            }           
          }  
        }
        if(reviewMessages && !Array.isArray(reviewMessages) && reviewMessages !== null){
         for(var message2 in reviewMessages){
            if(reviewMessages[message2] !== undefined && reviewMessages[message2] !== null && reviewMessages[message2]['timestamp']){
              sortMessages.push([message2, reviewMessages[message2]['timestamp'].seconds, false, "review"])
            }
          }   
        }
        if(issueMessages && !Array.isArray(issueMessages) && issueMessages !== null){
         for(var message3 in issueMessages){
            if(issueMessages[message3] !== undefined && issueMessages[message3] !== null && issueMessages[message3]['timestamp']){
              sortMessages.push([message3, issueMessages[message3]['timestamp'].seconds, null, "issue"])
            }
          }   
        }
        
        sortMessages.sort(function(a, b) {
         return a[1] - b[1];
        });

        //sortMessages = sortMessages.reverse();

      }
      
      var pendingCreateMess = [];

      for(var pc in sortedPendingCreate){
        var isMessage = false;
        for(var mess in sortMessages){
          if(messages && messages[sortMessages[mess][0]] && messages[sortMessages[mess][0]]['project']['id'] === sortedPendingCreate[pc]["id"]){
            pendingCreateMess.push([sortedPendingCreate[pc], sortMessages[mess][0]]);
            isMessage = true;
          }
        }
        if(!isMessage){
          pendingCreateMess.push([sortedPendingCreate[pc], false]);
        }
      }

      var pendingMess = [];

      for(var pc in sortedPending){
        var isMessage = false;
        for(var mess in sortMessages){
          if(messages && messages[sortMessages[mess][0]] && messages[sortMessages[mess][0]]['project']['id'] === sortedPending[pc]["id"]){
            pendingMess.push([sortedPending[pc], sortMessages[mess][0]]);
            isMessage = true;
          }
        }
        if(!isMessage){
          pendingMess.push([sortedPending[pc], false]);
        }
      }

    var reviewMess = [];

    for(var ur in sortedPendingReviews){
      var isMessage = false;
        for(var mess in sortMessages){
          if(reviewMessages && reviewMessages[sortMessages[mess][0]] && reviewMessages[sortMessages[mess][0]]['project']['id'] === sortedPendingReviews[ur]['id']){
            reviewMess.push([sortedPendingReviews[ur], sortMessages[mess][0]]);
            isMessage = true;
          } 
        }
        if(!isMessage){
          reviewMess.push([sortedPendingReviews[ur], false]);
        }
    }

    var issueMess = [];

    for(var im in this.state.issues){
      var isMessage = false;
        for(var mess in sortMessages){
          if(issueMessages && issueMessages[sortMessages[mess][0]] && issueMessages[sortMessages[mess][0]]['project'][0] === this.state.issues[im][0]){
            issueMess.push([this.state.issues[im], sortMessages[mess][0]]);
            isMessage = true;
          } 
        }
        if(!isMessage){
          issueMess.push([this.state.issues[im], false]);
        }
    }


		}

  
	  return (
    <div className="userDashboardContainer">
    { user && sortMessages && favorites && (issues || issues === null) && auth && pending && pendingCreate && restaurants && users && pendingReviews &&
	  	<div>
	        <div id="myModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunction}>&times;</span>
                <p>Are you sure you want to delete?</p>
                <p>{this.state.project.name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDelete}>Delete</button>
                </div>
              </div>
            </div>

            <div id="myModalCreate" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionCreate}>&times;</span>
                <p>Are you sure you want to delete?</p>
                <p>{this.state.project.name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteCreate}>Delete</button>
                </div>
              </div>
            </div>

            <div id="myModalIssue" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionIssue}>&times;</span>
                <p>Are you sure you want to delete?</p>
                <p>{this.state.project[0]}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteIssue}>Delete</button>
                </div>
              </div>
            </div>

            <div id="locateModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionLocate}>&times;</span>
                <p>Are you sure you want to update address?</p>
                <p>{this.state.project.address}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleLocate}>Update</button>
                </div>
              </div>
            </div>

            <div id="deleteReviewModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionDeleteReview}>&times;</span>
                <p>Are you sure you want to delete your review?</p>
                <p>{restaurants && this.state.project && this.state.project.restaurantId && 
                  restaurants.find(x=>x.restaurantId===this.state.project.restaurantId) &&
                  restaurants.find(x=>x.restaurantId===this.state.project.restaurantId).name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteReview}>Delete</button>
                </div>
              </div>
            </div>     
            
            <div id="deleteUserReviewModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionDeleteUserReview}>&times;</span>
                <p>Are you sure you want to delete your review?</p>
                <p>{restaurants && this.state.project && this.state.project.restaurantId && 
                  restaurants.find(x=>x.restaurantId===this.state.project.restaurantId) &&
                  restaurants.find(x=>x.restaurantId===this.state.project.restaurantId).name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteUserReview}>Delete</button>
                </div>
              </div>
            </div>  

      <div className="centerMe" style={{"display": "flex", "flexFlow":"column", "justifyContent": "center"}}>
      <div className="wrapper">
      { isAdmin && 
        <div className="row-admin" >
          <NavLink to='/AdminDashboard' >Admin Dashboard</NavLink>
        </div>
      }
      </div>
      <div className="wrapper" >
      <h5 onClick = {this.userInfoExpand} >User Info</h5>
        <div className="row" id='expandRow'>
          <p>{ this.state.userPoints + ' Points' }</p>
          <p>{ firstName +' '+ lastName }</p>
          <p>{ auth.email }</p>
          <p>{ 'Created at: ' + createdAt }</p>
          <p>{ 'Last login at: ' + lastLoginAt }</p>
          <div className="stopMarginBlockP">
          <p>{ 'Address: ' + userAddress }</p>
          <p>{user.city + ", " + user.state + " " + user.zip}</p>
          </div>
          <p>{ 'Location: ' + location }</p>
          <button className="btn pink lighten-1" id='changeAddress' onClick={this.handleSettings} >Settings</button>

        <div className="address-input" id='address-input'>
          <form className="address-form" onSubmit={this.handleSubmit}>
            <div className="input-field">
              <label htmlFor="address">Address</label>
              <input style={{color:"black"}} type="text" id='address' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="city">City</label>
              <input style={{color:"black"}} type="text" id='city' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="state">State</label>
              <input style={{color:"black"}} type="text" id='state' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="zip">Zip</label>
              <input style={{color:"black"}} type="text" id='zip' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <button className="btn pink lighten-1 z-depth-0" onClick={this.locateInterruptor}>Update Address</button>
            </div>
          </form>
        </div>
        </div>

      </div>
      <div className="wrapper">
      <h5  onClick = {this.messagesExpand} >{ sortMessages.length} messages</h5>
        { messages !== undefined && reviewMessages !== undefined && issueMessages !== undefined && restaurants && users &&
        <div className="row" id="messageExpand" > 
            { sortMessages &&
          Object.entries(sortMessages).map(thing=>{
          if(thing[1][2]){
            var timestamp = new Date(parseInt(messages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={messages[thing[1][0]].timestamp}>
              <span>{timestamp}</span>
              <br/>
              <span>{"Concerning your " + thing[1][3] + " of " + messages[thing[1][0]].project.name}</span>
              <br/>
              <span>
            {/*<Link to={'/message/' + auth.uid + '/' + thing[1][0] +'/null' } key={messages[thing[1][0]].project.id}>{ "Message from admin " + users.filter(user=>(user.id === messages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === messages[thing[1][0]].senderId))[0].lastName}</Link>*/}
              <Link to={'/message/' + auth.uid + '/' + thing[1][0] +'/null' } key={messages[thing[1][0]].project.id}>{ "Message from admin"}</Link>
              </span> 
              <p/>
              </div>
            )
          }
          else if(thing[1][2] === null){
            var timestamp3 = new Date(parseInt(issueMessages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            var timestamp4 = new Date(parseInt(issueMessages[thing[1][0]]['project'][1].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={'i'+ issueMessages[thing[1][0]].timestamp}>
              <span>{timestamp3}</span>
              <br/>
              <span>{"Concerning your issue on " +timestamp4 }</span>
              <br/>
              <span>
            {/*<Link to={'/issueMessage/' + auth.uid + '/' + thing[1][0] +'/null' } key={issueMessages[thing[1][0]].project[0]}>{  "Message from admin " + users.filter(user=>(user.id === issueMessages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === issueMessages[thing[1][0]].senderId))[0].lastName }</Link>*/}
              <Link to={'/issueMessage/' + auth.uid + '/' + thing[1][0] +'/null' } key={issueMessages[thing[1][0]].project[0]}>{  "Message from admin"}</Link>
              </span>
              <p/>
              </div>
            )
          }
          else{
            var timestamp2 = new Date(parseInt(reviewMessages[thing[1][0]].timestamp.seconds*1000, 10)).toLocaleString();
            return(
              <div key={'r'+reviewMessages[thing[1][0]].timestamp}>
              <span>{timestamp2}</span>
              <br/>
              <span>{"Concerning your review of " + restaurants.filter(restaurant=>restaurant.restaurantId === reviewMessages[thing[1][0]].project.restaurantId)[0]['name']  }</span>
              <br/>
              <span>
            {/*<Link to={'/reviewMessage/' + auth.uid + '/' + thing[1][0] +'/null' } key={reviewMessages[thing[1][0]].project.id}>{  "Message from admin " + users.filter(user=>(user.id === reviewMessages[thing[1][0]].senderId))[0].firstName + ' ' + users.filter(user=>(user.id === reviewMessages[thing[1][0]].senderId))[0].lastName }</Link>*/}
              <Link to={'/reviewMessage/' + auth.uid + '/' + thing[1][0] +'/null' } key={reviewMessages[thing[1][0]].project.id}>{  "Message from admin"}</Link>
              </span>
              <p/>
              </div>
            )
          }

          })

            }
        </div>
      }
      </div>
    
      <div className="wrapper">
      <h5 onClick = {this.pendingCreateExpand}> {contributions.pendingCreateLength+" "} Restaurants Pending Creation</h5>
        <div className="contributionsExpand" id="pendingCreateExpand">
          <div className="row2" >
            { pendingCreateMess && pendingCreateMess.map(project => {
            var timestampPC = new Date(parseInt(project[0].createdAt.seconds*1000, 10)).toLocaleString();
            return (
            <div key = { project[0].id } className="container-test">
              <div>
                <span>{timestampPC}</span>          
                <RestaurantSummary userId={auth.uid} message={project[1]} key={ project[0].id + 'pendingCreate' } allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={project[0]} favorite = {false}/>
                <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "space-between"}}>
                  <button project={project[0]} className="btn pink lighten-1" onClick={()=>{this.deleteCreateInterruptor(project[0])}}>Delete</button>
                  <button project={project[0]} className="btn pink lighten-1" onClick={()=>{this.editCreate(project[0])}}>Edit</button>
                </div>
                <p> </p>
              </div>
              </div>
              )
            })}
          </div>
        </div>
      </div>

      <div className="wrapper">
      <h5 onClick = {this.pendingEditExpand}> {contributions.pendingLength+" "} Restaurants Pending Edit</h5>
        <div className="contributionsExpand" id="pendingEditExpand">
          <div className="row2" >
          <p>The sections in which you have made changes are outlined in red.</p>
          { pendingMess && pendingMess.map(project => {
          var timestampP = new Date(parseInt(project[0].editedAt.seconds*1000, 10)).toLocaleString();
          return (
          <div key = { project[0].id + '1'}>
            <div className="container-test-compare">
              <div>
              <span>{timestampP}</span>
              <RestaurantCompare userId={auth.uid} message={project[1]} original={restaurants.find(x=>x.restaurantId===project[0].restaurantId)} allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={project[0]} favorite = {false}/>
              <div className = 'adminButtons' style={{"width":"100%", "display": "flex", "justifyContent": "space-around"}}>
                <button project={project[0]} className="btn pink lighten-1" onClick={()=>{this.deleteInterruptor(project[0])}}>Delete</button>
                <button className="btn pink lighten-1" onClick={()=>{this.handleCompare(project[0])}}>Compare</button>
              </div>
              </div>
            <div className='center-vertical'>  
              <div id={project[0].id + 'compare'} style={{"display":"none"}}>
                <p> </p>
                <RestaurantSummary id={project[0].id+'compareRestaurant'} allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={restaurants.find(x=>x.restaurantId===project[0].restaurantId)} favorite = {false}/>
                <span className="close2" onClick={()=>{this.closeCompare(project[0])}}>&times;</span>
              </div>              
            </div>  
            </div>
          </div>
            )
          })}
        </div>
        </div>
      </div>

      <div className="wrapper">
      <h5 onClick = {this.pendingReviewsExpand}> {contributions.pendingReviewsLength+" "} Pending Reviews</h5>
        <div className="contributionsExpand" id="pendingReviewsExpand">
        <p> Click on the name of the restaurant to expand. </p>
          <div className="row2" >
          { reviewMess && reviewMess.map(project => {
          var timestampPR = new Date(parseInt(project[0].timestamp.seconds*1000, 10)).toLocaleString();
          return (
          <div key = { project[0].id } className="container-test">
            <div className="outerReviewContainer">
            <span>{timestampPR}</span>
            <br/>
            {
              project[1] &&
              <ReviewSummary userId={auth.uid} message={project[1]} project={ project[0] } original={restaurants.find(x=>x.restaurantId===project[0].restaurantId)} />
            }
            {
              !project[1] &&
              <ReviewSummary project={ project[0] } original={restaurants.find(x=>x.restaurantId===project[0].restaurantId)} />
            }
              <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
                <button project={project[0]} className="btn pink lighten-1" onClick={()=>{this.deleteReviewInterruptor(project[0])}}>Delete</button>      
              </div>
            </div>
          </div>
            )
          })}
        </div>
        </div>
      </div>

      <div className="wrapper">
      <h5 onClick = {this.issuesExpand}>{(this.state.issues && this.state.issues.length+" ") || "0"} Issues</h5>
        <div className="contributionsExpand" id="issuesExpand">
        <p> Click on the date to expand the issue. </p>
        <div className="row2">
          <div>
          { issueMess && issueMess.map(project => {
          var timestampIss = new Date(parseInt(project[0][1].timestamp.seconds*1000, 10)).toLocaleString();
          return (
            <div key = { project[0][0] } className="container-test">
              <div className='outerReviewContainer' >
              {
                project[1] &&
                <IssueSummary userId={auth.uid} message={project[1]} project={ project[0] } />
              }
              {
                !project[1] &&
                <IssueSummary project={project[0]}/>
              }
                <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
                  <button project={project[0]} className="btn pink lighten-1" onClick={()=>{this.deleteIssueInterruptor(project[0])}}>Delete</button>      
                </div>
              </div>
            </div>
          )
          })}
          </div>
        </div>
        </div>
      </div>


      {/*<div className="wrapper">
      <h5 onClick = {this.contributionsExpand}>{contributions.createdLength+" "} Contributions</h5>
        <div className="contributionsExpand" id="contributionsExpand">
        <div className="row2">
          <p>{ "Created " + contributions.createdLength + " restaurants" }</p>
          <div className="container-test" >
          { sortedCreated && sortedCreated.map(project => {
          var timestampC = new Date(parseInt(project.createdAt.seconds*1000, 10)).toLocaleString();
          return (
          <div key={ project.id + 'create' }>
            <span>{timestampC}</span>
            <RestaurantSummary allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={project} favorite = {false}/>
          </div>  
            )
          })}
          </div>
        </div>
        {/*<div className="row2" >
                  <p>{ "Edited " + contributions.editedLength + " restaurants" }</p>
                  <div className="container-test" >
                  { sortedEdited && sortedEdited.map(project => {
                  var timestampE = new Date(parseInt(project.editedAt.seconds*1000, 10)).toLocaleString();
                  return (
                  <div key={ project.id + 'edit' }>
                    <span>{timestampE}</span>
                    <RestaurantSummary allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={project} favorite = {false}/>
                  </div>  
                    )
                  })}
                  </div>
                </div>
        </div>
      </div>*/}

      <div className="wrapper">
      <h5 onClick = {this.userReviewsExpand}>{this.props.reduxStore && this.props.reduxStore.userReviews && this.props.reduxStore.userReviews.length+" "} Reviews</h5>
        <div className="contributionsExpand" id="userReviewsExpand">
        <div className="row2">
        <p> Click on a restaurant name to expand the review. </p>
          <div className="container-test" >
          { this.props.reduxStore && this.props.reduxStore.userReviews && this.props.reduxStore.userReviews.map(project => {
          var timestampR = new Date(parseInt(project[1].timestamp.seconds*1000, 10)).toLocaleString();
          return (
            <div key = { project[0] } className="container-test">
              <div className="outerReviewContainer">
                <span>{timestampR}</span>
                <ReviewSummary project={ project[1] } original={restaurants.find(x=>x.restaurantId===project[1].restaurantId)} />
                <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
                  <button project={project} className="btn pink lighten-1" onClick={()=>{this.deleteUserReviewInterruptor(project)}}>Delete</button>      
                </div>
              </div>
            </div>
          )
          })}
          </div>
        </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="input-field" style={{"display":"flex", "justifyContent":"center"}} >
          <button className="btn pink lighten-1 z-depth-0" onClick={(state)=>this.handleSignOut(state)}>Sign Out</button>
        </div>
      </div>

      <div className="row">
      <h5>New Restaurants</h5>
        <div className="row" >
          <p>{ newRestaurantsLength + " new restaurants since last visit" }</p>
          { newRestaurants && newRestaurants.length > 0 && newRestaurants !== {} && newRestaurants.map(project => {
        	return (
        	<div key = { project.id }>
          		<RestaurantSummary onFavorite = {this.onFavorite} project={project} allContent = "" favorite = {(project.id in {...favorites} && favorites[project.id].favorite === true )}/>
          		<p> </p>
          	</div>
        		)
      		})}
        </div>
      </div>
      </div>
      </div>
    }
    </div>
    )

	}	
}


const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    reviews: state.firestore.data.restaurantReviews2,
    messages: state.firestore.data.messages,
    reviewMessages: state.firestore.data.reviewMessages,
    issueMessages: state.firestore.data.issueMessages,
    restaurants: state.firestore.ordered.restaurants,
    users: state.firestore.ordered.users,
    favorites: state.firestore.data.favorites,
    pending: state.firestore.ordered.pending,
    pendingCreate: state.firestore.ordered.pendingCreate,
    pendingReviews: state.firestore.ordered.pendingReviews,
    reduxStore: state.reduxStore,
    points: state.firestore.data.points,
    issues: state.firestore.data.issues,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => dispatch(signOut()),
    addFavorite: (project) => dispatch(addFavorite(project)),
    deleteRestaurantAdmin: (project) => dispatch(deleteRestaurantAdmin(project)),
    deleteRestaurantCreateAdmin: (project) => dispatch(deleteRestaurantCreateAdmin(project)),
    backupRestaurantAdmin: (project) => dispatch(backupRestaurantAdmin(project)),
    deleteReviewAdmin: (project) => dispatch(deleteReviewAdmin(project)),
    backupReviewAdmin: (project) => dispatch(backupReviewAdmin(project)),
    deleteIssueAdmin: (issueId) => dispatch(deleteIssueAdmin(issueId)),
    backupIssueAdmin: (project) => dispatch(backupIssueAdmin(project)),
    deleteUserReviewAdmin: (project, reviewId) => dispatch(deleteUserReviewAdmin(project, reviewId)),
    backupUserReviewAdmin: (project) => dispatch(backupUserReviewAdmin(project)),
    setAddress: (state, zip, city, address, location, user) => dispatch(setAddress(state, zip, city, address, location, user)),
    updateReduxUserReviews: (userReviews) => dispatch(updateReduxUserReviews(userReviews))
  }
}

const enhance = compose(
  firebaseConnect([
    { path: 'pendingCreate', queryParams: ['orderByKey', 'limitToFirst=10' ] }
  ]),
  connect(mapStateToProps,mapDispatchToProps)  
)

export default enhance(UserDashboard)